import React from 'react';
import ModalWrapper from './ModalWrapper';
import CustomButton from 'components/custom-button/CustomButton';
import { ButtonType } from 'components/custom-button/CustomButton';
import { ReactComponent as CrownIcon } from 'assets/icons/CrownIcon.svg';
import { ReactComponent as GreenFilledTickIcon } from 'assets/icons/GreenFilledTickIcon.svg';
import { FSMSubscriptionIcon, ModalCloseIcon } from 'assets/icons';
import { VoidFn } from 'types/baseTypes';

interface FSMSubscriptionModalProps {
  onChoosePlan: () => void;
  showCloseButton?: boolean;
  handleClose: VoidFn;
}

const features = [
  'Create and collaborate on unlimited jobs',
  'Link estimates and invoices for full job history',
  'Track pay automatically with Commission Rules',
  'Add job expenses to see true profitability'
];

const plusFeatures = [
  'Assign jobs with Service Areas',
  'Track referrals using External Companies',
  'Dispatch faster with Map View',
  'Monitor your business with Reports',
  'Save time with Pay Runs & Accounting tools'
];

const FSMSubscriptionModal: React.FC<FSMSubscriptionModalProps> = ({ onChoosePlan, showCloseButton, handleClose }) => {
  const handleChatWithUsClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (window.fcWidget) window.fcWidget.open();
  };

  return (
    <ModalWrapper>
      <div
        className="customTransparentScroll max-h-[90vh] w-[90%] max-w-4xl overflow-auto
      rounded-2xl bg-white px-6 pt-8 pb-6 shadow-xl md:w-[579px]">
        {showCloseButton && (
          <div className="absolute right-3 top-3 cursor-pointer" onClick={handleClose}>
            <ModalCloseIcon width={25} height={25} />
          </div>
        )}
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-secondaryBtn">
          <FSMSubscriptionIcon className="h-10 w-10" />
        </div>
        <h2 className="mb-2 text-center text-2xl font-bold text-heading">Manage your jobs and team with Field Serve</h2>
        <p className="mb-6 text-center text-17px text-primaryText">
          Dispatch your team, track pay, and manage jobs from anywhere.
        </p>
        <div className="mb-6 w-full rounded-md border border-gray-1 p-6 py-4">
          <div className="mb-9">
            <span className="text-sbase font-semibold text-primaryText">Manage your team from anywhere</span>
            <ul className="mt-3 space-y-3">
              {features.map(feature => (
                <li key={feature} className="flex items-center gap-2 text-sbase font-medium text-primaryText">
                  <GreenFilledTickIcon aria-label="Included" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <span className="text-sbase font-semibold text-primaryText">Do even more on your Field Serve Plus</span>
            <ul className="mt-3 space-y-3">
              {plusFeatures.map(feature => (
                <li key={feature} className="flex items-center gap-2 text-sbase font-medium text-primaryText">
                  <CrownIcon aria-label="Plus Feature" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <CustomButton
          id="fsm-choose-plan-btn"
          type={ButtonType.PRIMARY}
          className="h-12 w-full text-base font-semibold"
          onClick={onChoosePlan}>
          Choose your plan
        </CustomButton>
        <div className="mt-4 w-full text-center text-sbase text-accentText">
          Need help?{' '}
          <button
            type="button"
            tabIndex={0}
            aria-label="Chat with us"
            className="font-bold text-secondary"
            onClick={handleChatWithUsClick}>
            Chat with us
          </button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default FSMSubscriptionModal;
